import SectionHeader from '@Web/Src/Components/SectionHeader';
import VideoSection from '@Web/Src/UI/VideoSection';
import { assetUrl } from '@Shared/Helpers/Utilities';

function IntegrationVideo({ name, videoUrl, videoImg }) {
    return (
        <>
            <SectionHeader
                type='dark'
                className='mx-auto mt-20'
                icon='video'
                title={__('Watch how it works')}
                desc={
                    <>
                        {__(
                            'Ready to get more referrals and grow your business? Watch this video to learn how to integrate your '
                        )}
                        <a
                            href={
                                'https://referral-factory.com/learn/how-to-create-a-referral-program'
                            }
                            target={'_blank'}
                            className={'cursor-pointer underline'}
                        >
                            {__('referral program')}
                        </a>
                        {__(` directly with ${name}.`)}
                    </>
                }
            />
            <VideoSection
                src={videoUrl}
                videoImg={assetUrl(
                    `/assets/images/webp/web/integrations/${videoImg}-video.webp`
                )}
            />
        </>
    );
}

export default IntegrationVideo;
